import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-commerce-service',
  templateUrl: './e-commerce-service.component.html',
  styleUrls: ['./e-commerce-service.component.scss']
})
export class ECommerceServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
